export const ROLES = {
  CS: 'cs', // role group includes csm, csa
  CSM: 'csm',
  CSADMIN: 'csAdmin',
  SUPPORT_SPECIALIST: 'supportSpecialist',
  SALES: 'sales',
  CLIENT_ADMIN: 'clientAdmin',
  DACH_ADMIN: 'dachAdmin',
  HR: 'hr', // hr role and role group wich includes hr, clientAdmin
  DISTRIBUTOR: 'distributor',
  EXPERT: 'expert',
  STUDENT: 'student',
  DEMO: 'demo'
};

export const ASSIGNABLE_ROLES = {
  csm: [
    'cs',
    'csm',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'creator',
    'distributorManager',
    'distributor',
    'expert',
    'student',
    'salesChief'
  ],
  supportSpecialist: [
    'cs',
    'csm',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'creator',
    'distributorManager',
    'distributor',
    'expert',
    'student',
    'salesChief'
  ],
  csAdmin: [
    'cs',
    'csm',
    'supportSpecialist',
    'csAdmin',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'creator',
    'distributorManager',
    'distributor',
    'expert',
    'student',
    'salesChief'
  ],
  sales: [],
  distributorManager: [
    'distributor',
    'expert',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'creator',
    'student'
  ],
  clientAdmin: ['clientAdmin', 'dachAdmin', 'hr', 'creator', 'student'],
  dachAdmin: ['clientAdmin', 'dachAdmin', 'hr', 'creator', 'student'],
  hr: [],
  distributor: ['distributor', 'creator', 'clientAdmin', 'dachAdmin', 'hr', 'student'],
  expert: ['expert', 'creator', 'student'],
  student: [],
  demo: [],
  superAdmin: [
    'cs',
    'csm',
    'supportSpecialist',
    'csAdmin',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'creator',
    'distributorManager',
    'distributor',
    'expert',
    'student',
    'salesChief',
    'superAdmin'
  ]
};

export const ALL_ROLES = [
  'cs',
  'csm',
  'supportSpecialist',
  'csAdmin',
  'sales',
  'clientAdmin',
  'dachAdmin',
  'hr',
  'creator',
  'distributorManager',
  'distributor',
  'expert',
  'student',
  'salesChief',
  'superAdmin'
];

export const GLOBAL_ROLES = {
  distributor: 'distributor',
  expert: 'expert'
};

export const STUDENT_ROLE = 'student';
export const SELECT_ROLE_FORM = 'account.forms.selectRole';

/*CSV SERVICE*/
export const CSV_FIELD_NAMES = ['name', 'email', 'surname', 'role', 'blocked'];
export const EOL = '\r\n';
export const BOM = '\ufeff';
export const DEFAULT_FIELD_SEPARATOR = ',';
export const DEFAULT_DECIMAL_SEPARATOR = '.';
export const DEFAULT_QUOTE = '"';
export const DEFAULT_SHOW_TITLE = false;
export const DEFAULT_TITLE = 'My Report';
export const DEFAULT_FILENAME = 'mycsv.csv';
export const DEFAULT_SHOW_LABELS = false;
export const DEFAULT_USE_BOM = true;
export const DEFAULT_HEADER = [];
export const ConfigDefaults = {
  filename: DEFAULT_FILENAME,
  fieldSeparator: DEFAULT_FIELD_SEPARATOR,
  quoteStrings: DEFAULT_QUOTE,
  decimalseparator: DEFAULT_DECIMAL_SEPARATOR,
  showLabels: DEFAULT_SHOW_LABELS,
  showTitle: DEFAULT_SHOW_TITLE,
  title: DEFAULT_TITLE,
  useBom: DEFAULT_USE_BOM,
  headers: DEFAULT_HEADER
};
